var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17.6978,
    r: 17.5,
    fill: "#58A84A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 24.3643C10.8753 24.3643 10.483 24.2011 10.1566 23.8748C9.83019 23.5484 9.66699 23.156 9.66699 22.6977V12.6977C9.66699 12.2393 9.83019 11.847 10.1566 11.5206C10.483 11.1942 10.8753 11.031 11.3337 11.031H24.667C25.1253 11.031 25.5177 11.1942 25.8441 11.5206C26.1705 11.847 26.3337 12.2393 26.3337 12.6977V22.6977C26.3337 23.156 26.1705 23.5484 25.8441 23.8748C25.5177 24.2011 25.1253 24.3643 24.667 24.3643H11.3337ZM18.0003 18.531L11.3337 14.3643V22.6977H24.667V14.3643L18.0003 18.531ZM18.0003 16.8643L24.667 12.6977H11.3337L18.0003 16.8643ZM11.3337 14.3643V12.6977V22.6977V14.3643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateUserIcon);
export default __webpack_public_path__ + "static/media/create-user-icon.68d424b91c23b6b484167dc3a018b7dd.svg";
export { ForwardRef as ReactComponent };